module.exports = [{
      plugin: require('../../../../gatsby/node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../../gatsby/node_modules/gatsby-plugin-fontawesome-css/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../../gatsby/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"HBO Max Toolkit","short_name":"HBO Max Toolkit","description":"Stream the most talked about shows and movies featuring the worlds of HBO, the DC Universe, Harry Potter, and more on HBO Max.","start_url":"/","background_color":"#000000","theme_color":"#ffffff","display":"standalone","icon":"./static/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"c6330367c8076a0462cffcfbec22ae07"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
